import { render, staticRenderFns } from "./CrudCargoDetailDialog.vue?vue&type=template&id=5ada7846"
import script from "./CrudCargoDetailDialog.vue?vue&type=script&lang=js"
export * from "./CrudCargoDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./CrudCargoDetailDialog.vue?vue&type=style&index=0&id=5ada7846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports